import { Injectable } from '@angular/core';
import { apiUrl } from '../constants/apiUrl';
import { HttpRequestService } from '../services/http-request.service';

@Injectable({
    providedIn: 'root',
})
export class GenerateTokenAPI {
    constructor(private httpRequestService: HttpRequestService) {}

    getToken = async (refreshToken: string) => {
        try {
            const url = `${apiUrl.getToken}?refreshToken=${refreshToken}`;
            const response = await this.httpRequestService.axiosGet(url);
            return response;
        } catch (error) {
            return error.toString();
        }
    };
}
